<template>
  <div class="paper-choice-student">
    <PaperWrap>
      <template #default="{paperBatchId}">
        <div class="cont-wrap">
          <el-tabs v-model="activeTab" v-if="paperBatchId">
            <el-tab-pane v-for="tab in tabs"
                         :key="tab.value"
                         :name="tab.value"
                         :label="tab.label"
                         lazy>
              <component :is="tab.component"
                         :paper-batch-id="paperBatchId"
                         :active-tab="activeTab === tab.value"></component>
            </el-tab-pane>
          </el-tabs>
          <Hint v-else>请先选择论文批次</Hint>
        </div>
      </template>
    </PaperWrap>
  </div>
</template>

<script>
import PaperChoiceStudentFirst from './first'
import PaperChoiceStudentSecond from './second'
import PaperChoiceStudentThird from './third'
import PaperChoiceStudentAll from './all'
import PaperWrap from '../../wrap'
import Hint from '../../../../../../elements/Hint.vue'
export default {
  name: 'PaperChoiceStudent',
  components: {
    Hint,
    PaperWrap
  },
  data () {
    return {
      activeTab: 'all',
      tabs: [{
        label: '全部',
        value: 'all',
        component: PaperChoiceStudentAll
      }, {
        label: '第一志愿',
        value: 'first',
        component: PaperChoiceStudentFirst
      }, {
        label: '第二志愿',
        value: 'second',
        component: PaperChoiceStudentSecond
      }, {
        label: '第三志愿',
        value: 'third',
        component: PaperChoiceStudentThird
      }]
    }
  }
}
</script>

<style scoped lang="scss">
.paper-choice-student{
  height: 100%;
  .cont-wrap{
    height: 100%;
    ::v-deep  .el-tabs {
      height: 100%;
      display: flex;
      flex-direction: column;
      &.el-tabs--top {
        position: relative;
        height: 100%;
        & > .el-tabs__header {
          margin-bottom: 0;
          padding: 0 15px;
          box-sizing: border-box;
          background-color: #fff;
          & > .el-tabs__nav-wrap {
            & > .el-tabs__nav-scroll {
              & > .el-tabs__nav {
                & > .el-tabs__item {
                  min-width: 92px;
                  height: 36px;
                  font-size: 12px;
                  text-align: center;
                  line-height: 36px;
                }
              }
            }
          }
        }
        & > .el-tabs__content {
          flex: 1;
          height: 0;
          & > .el-tab-pane {
            height: 100%;
            padding: 10px 20px;
            background-color: #fff;
          }
        }
      }
    }
  }
}
</style>
